// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__rzNvD","logoPlaceholder":"styles_logoPlaceholder__voPwA"};